import config from '@lottery.2.0/library/config.js'
export default {
	...config,
	mobile : true,
}